import { getUnslottedChildren } from "@/mds/utils/slots";
import { getSlot } from "@/mds/utils/slots";
import { StyledGridListItem, StyledItemContent } from "./grid-list-item.style";
import { MDSGridListItemProps, MDSGridListItemSlotName } from "./grid-list-item.types";

export const MDSGridListItem = ({ children, ...props }: MDSGridListItemProps) => {
  const unslottedChildren = getUnslottedChildren(children);
  const leftAddon = getSlot(children, MDSGridListItemSlotName.LeftAddon);
  const rightAddon = getSlot(children, MDSGridListItemSlotName.RightAddon);

  return (
    <StyledGridListItem {...props}>
      {leftAddon}
      <StyledItemContent>{unslottedChildren}</StyledItemContent>
      {rightAddon}
    </StyledGridListItem>
  );
};
